import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";

import Examples from "../../Docs/Components/Image/ImageExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Image"
            description="Renders an image."
            apiSources={["azure-devops-ui/Components/Image/Image.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"Planned (Q3)"}}
        />
    );
}
}
        
export default Page;